import axiosInstance from "../../utils/axiosInstance";
import {ALERT_CONTACT_ACTION_TYPES} from "../typesAction";


export const setLoading = () => {
    return {type: ALERT_CONTACT_ACTION_TYPES.LOAD_ALERT_CONTACT}
};

export const clearLoading = () => {
    return {type: ALERT_CONTACT_ACTION_TYPES.CLEAR_LOAD_ALERT_CONTACT}
};

export const clearAlertContactError = () => {
    return {type: ALERT_CONTACT_ACTION_TYPES.CLEAR_ALERT_CONTACT_ERRORS}
};

export const listAlertContacts = (history, pagination, filters = {}, sorter) => async dispatch => {
    try {
        dispatch(setLoading());
        // Prepare all query parameters
        let queryParameters = {}
        Object.keys(filters).map(key => (
            queryParameters[key] = filters[key] == null ? filters[key] : filters[key][0])
        );
        if (sorter !== undefined) {
            queryParameters['sort'] = sorter['field']
            queryParameters['order'] = sorter['order'] === 'descend' ? 'desc' : 'asc'
        }
        if (pagination !== undefined) {
            queryParameters['offset'] = (pagination.current - 1) * pagination.pageSize
            queryParameters['max'] = pagination.pageSize
        }
        // Spread the parameters
        const params = {
            ...queryParameters
        };
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).get('/alertContact', {params});
        // Update state
        
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.LIST_ALERT_CONTACT,
            payload: data
        });
    } catch (err) {
        console.log(err);
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.ERROR_ALERT_CONTACT,
            payload: err.message
        });
    }
};

export const addAlertContact = (history, alertContact, setAlertContactCreated) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).post('/alertContact', alertContact);
        // Update state
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.ADD_ALERT_CONTACT,
            payload: data
        });
        setAlertContactCreated(true);
    } catch (err) {
        console.log(err);
        const error = await err.response.data;
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.ERROR_ALERT_CONTACT,
            payload: error
        });
    }
};

export const getAlertContact = (history, id) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request
        const {data} = await axiosInstance(history, dispatch).get(`/alertContact/${id}`);
        // Update state
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.SHOW_ALERT_CONTACT,
            payload: data
        });
        return data;
    } catch (err) {
        console.log(err);
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.ERROR_ALERT_CONTACT,
            payload: err.message
        });
    }
};

export const editAlertContact = (history, id, alertContact, setAlertContactCreated) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request and get data
        const {data} = await axiosInstance(history, dispatch).patch(`/alertContact/${id}`, alertContact);
        // Update state
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.EDIT_ALERT_CONTACT,
            payload: data
        });
        setAlertContactCreated(true);
    } catch (err) {
        console.log(err);
        const error = await err.response.data;
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.ERROR_ALERT_CONTACT,
            payload: error
        });
    }
};

export const deleteAlertContact = (history, id) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request
        await axiosInstance(history, dispatch).delete(`/alertContact/${id}`);
        // Update state
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.DELETE_ALERT_CONTACT,
            payload: id
        });
    } catch (err) {
        console.log(err);
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.ERROR_ALERT_CONTACT,
            payload: err.message
        });
    }
};


export const notifyAlertContact = (history, id) => async dispatch => {
    try {
        dispatch(setLoading());
        // Send request
        await axiosInstance(history, dispatch).get(`/alertContact/${id}`);
        // Update state
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.DELETE_ALERT_CONTACT,
            payload: id
        });
    } catch (err) {
        console.log(err);
        dispatch({
            type: ALERT_CONTACT_ACTION_TYPES.ERROR_ALERT_CONTACT,
            payload: err.message
        });
    }
};
